import React, { useState, useEffect } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import UseTitle from "../../components/useTitle";
import "./JobTemplateNew.scss";

const JobTemplateNew = () => {
  // Définition du titre de la page
  UseTitle("Création d'un métier");

  const [name, setName] = useState();
  const [description, setDescription] = useState();
  const [isNatal, setIsNatal] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [messageError, setMessageError] = useState([]);

  const [redirectTo, setRedirectTo] = useState();

  // SKILL variables
  const [skillSearch, setSkillSearch] = useState("");
  const [skillPageSize, setSkillPageSize] = useState(6);
  const [skillPage, setSkillPage] = useState(1);
  const [skillListTemplates, setSkillListTemplates] = useState([]);
  const [skillListInfos, setSkillListInfos] = useState([]);
  const [skillsTemplates, setSkillsTemplates] = useState([]);
  const [skillIsInitialLoading, setSkillIsInitialLoading] = useState(true);
  const [skillIsRefreshing, setSkillIsRefreshing] = useState(false);

  // SPELL variables
  const [spellSearch, setSpellSearch] = useState("");
  const [spellPageSize, setSpellPageSize] = useState(6);
  const [spellPage, setSpellPage] = useState(1);
  const [spellListTemplates, setSpellListTemplates] = useState([]);
  const [spellListInfos, setSpellListInfos] = useState([]);
  const [spellsTemplates, setSpellsTemplates] = useState([]);
  const [spellIsInitialLoading, setSpellIsInitialLoading] = useState(true);
  const [spellIsRefreshing, setSpellIsRefreshing] = useState(false);

  const checkJobTemplate = () => {
    const errors = [];
    if (!name) errors.push("Veuillez renseigner le nom");

    if (errors.length > 0) {
      setIsFormValid(false);
      setMessageError(errors);
    } else {
      setIsFormValid(true);
      setMessageError([]);
    }
  };

  // SKILL methods
  const handleSkillPageChange = (newSkillPage) => {
    setSkillPage(newSkillPage);
  };

  const handleSkillTemplateChange = (selectedSkillTemplate) => {
    const skillId = selectedSkillTemplate.id;

    setSkillsTemplates((prevSkills) => {
      const updatedNewSkills = prevSkills.some((skill) => skill.id === skillId)
        ? prevSkills.filter((skill) => skill.id !== skillId)
        : [...prevSkills, selectedSkillTemplate];

      // Trie les compétences par nom
      // Utiliser 'a.id - b.id' si on veut de trier par id
      return updatedNewSkills.sort((a, b) => a.name.localeCompare(b.name));
    });
  };

  // SPELL methods
  const handleSpellPageChange = (newSpellPage) => {
    setSpellPage(newSpellPage);
  };

  const handleSpellTemplateChange = (selectedSpellTemplate) => {
    const spellId = selectedSpellTemplate.id;

    setSpellsTemplates((prevSpells) => {
      const updatedNewSpells = prevSpells.some((spell) => spell.id === spellId)
        ? prevSpells.filter((spell) => spell.id !== spellId)
        : [...prevSpells, selectedSpellTemplate];

      // Trie les sorts par nom
      // Utiliser 'a.id - b.id' si on veut de trier par id
      return updatedNewSpells.sort((a, b) => a.name.localeCompare(b.name));
    });
  };

  const handleNew = () => {
    if (!isFormValid) return;

    setIsLoading(true);

    const skillTemplateIds = skillsTemplates.map(
      (skillTemplate) => skillTemplate.id
    );
    const spellTemplateIds = spellsTemplates.map(
      (spellTemplate) => spellTemplate.id
    );

    const job_template_data = {
      name: name,
      description: description,
      is_natal: isNatal,
      skills_templates_ids: skillTemplateIds,
      spells_templates_ids: spellTemplateIds,
    };

    api
      .post(`/jobtemplate/`, job_template_data)
      .then((response) => {
        setRedirectTo(`/job/${response.data.id}`);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // SKILL search
  useEffect(() => {
    const fetchSkillTemplates = async () => {
      if (skillListTemplates.length === 0) setSkillIsInitialLoading(true);
      else setSkillIsRefreshing(true);

      try {
        const response = await api.get(
          `/skilltemplate/?search=${skillSearch}&ordering=name&page_size=${skillPageSize}&page=${skillPage}`
        );
        setSkillListTemplates(response.data.results);
        setSkillListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setSkillIsInitialLoading(false);
        setSkillIsRefreshing(false);
      }
    };

    fetchSkillTemplates();
  }, [skillSearch, skillPage, skillPageSize]);

  // SPELL search
  useEffect(() => {
    const fetchSpellTemplates = async () => {
      if (spellListTemplates.length === 0) setSpellIsInitialLoading(true);
      else setSpellIsRefreshing(true);

      try {
        const response = await api.get(
          `/spelltemplate/?search=${spellSearch}&ordering=name&page_size=${spellPageSize}&page=${spellPage}`
        );
        setSpellListTemplates(response.data.results);
        setSpellListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setSpellIsInitialLoading(false);
        setSpellIsRefreshing(false);
      }
    };

    fetchSpellTemplates();
  }, [spellSearch, spellPage, spellPageSize]);

  useEffect(() => {
    checkJobTemplate();
  }, [name]);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="job-template-new">
        {isLoading ? (
          <div className="loading-screen">
            <div className="loading-spinner"></div>
            <div className="loading-text">Chargement de l'application...</div>
          </div>
        ) : (
          <>
            {/* Header du personnage */}
            <div className="header">
              <h1>Nouveau métier</h1>
            </div>
            <form
              className="job-template-new-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleNew();
              }}
            >
              {/* Informations générales */}
              <div className="infos update-section">
                <h2>Informations</h2>
                <div className="info">
                  <label htmlFor="name">Nom </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    autoComplete="off"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="info">
                  <label htmlFor="description">Description </label>
                  <textarea
                    name="description"
                    id="description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <div className="info">
                  <label htmlFor="is_natal">Métier de région de départ </label>
                  <input
                    type="checkbox"
                    name="is_natal"
                    id="is_natal"
                    checked={isNatal}
                    onChange={(e) => setIsNatal(e.target.checked)}
                  />
                </div>
              </div>

              {/* Compétences / Sorts */}
              <div className="update-section">
                <h2>Compétences / Sorts</h2>
                {/* Compétences */}
                <div className="update-elements">
                  <h3>Compétences ({skillsTemplates.length})</h3>
                  {skillListTemplates.length !== 0 &&
                    skillsTemplates.map((skillsTemplates, index) => (
                      <div className="update-element" key={index}>
                        <span>
                          {skillsTemplates.name}{" "}
                          <small>
                            (
                            {skillsTemplates.attributes
                              .map((attribute) => attribute.full_name)
                              .join(", ")}
                            )
                          </small>
                        </span>
                        <button
                          type="button"
                          className="bt remove"
                          onClick={() =>
                            handleSkillTemplateChange(skillsTemplates)
                          }
                        >
                          -
                        </button>
                      </div>
                    ))}
                </div>
                {/* Sorts */}
                <div className="update-elements">
                  <h3>Sorts ({spellsTemplates.length})</h3>
                  {spellListTemplates.length !== 0 &&
                    spellsTemplates.map((spellsTemplates, index) => (
                      <div className="update-element" key={index}>
                        <span>
                          {spellsTemplates.name}{" "}
                          <small>
                            (
                            {spellsTemplates.attributes
                              .map((attribute) => attribute.full_name)
                              .join(", ")}
                            )
                          </small>
                        </span>
                        <button
                          type="button"
                          className="bt remove"
                          onClick={() =>
                            handleSpellTemplateChange(spellsTemplates)
                          }
                        >
                          -
                        </button>
                      </div>
                    ))}
                </div>
              </div>

              {/* Ajout des compétences / sorts */}
              <div className="update-section">
                <h2>Ajouter Compétences / Sorts</h2>

                {/* Ajout des compétences */}
                <div className="add-element list-page">
                  <h3>Liste des compétences ({skillListInfos.count})</h3>
                  {/* Filtres */}
                  <div className="filters">
                    <div className="skill-search">
                      <label htmlFor="skillsearch">Rechercher </label>
                      <input
                        type="text"
                        name="skillsearch"
                        id="skillsearch"
                        value={skillSearch}
                        onChange={(e) => (
                          setSkillSearch(e.target.value), setSkillPage(1)
                        )}
                      />
                    </div>
                    <div className="skill-pagesize">
                      <label htmlFor="skillpagesize">Taille de la page </label>
                      <select
                        name="skillpagesize"
                        id="skillpagesize"
                        value={skillPageSize}
                        onChange={(e) => (
                          setSkillPageSize(e.target.value), setSkillPage(1)
                        )}
                      >
                        <option value="6">6</option>
                        <option value="12">12</option>
                        <option value="24">24</option>
                      </select>
                    </div>
                  </div>

                  {/* Chargement initial */}
                  {skillIsInitialLoading && (
                    <div className="loading-data">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">Chargement...</div>
                    </div>
                  )}

                  {/* Liste des compétences */}
                  {!skillIsInitialLoading &&
                    (skillListTemplates.length === 0 ? (
                      <div className="no-data">
                        <strong>Aucune compétence trouvée</strong>
                      </div>
                    ) : (
                      <div
                        className={`list-div skills ${
                          skillIsRefreshing ? "loading" : ""
                        }`}
                      >
                        {skillListTemplates.map((skillListTemplates) => {
                          const isSkillSelected = skillsTemplates.some(
                            (skills) => skills.id === skillListTemplates.id
                          );

                          return (
                            <div
                              className="list-card"
                              key={skillListTemplates.id}
                            >
                              {skillListTemplates.name} (
                              {skillListTemplates.attributes
                                .map((attribute) => attribute.full_name)
                                .join(", ")}
                              )
                              <button
                                type="button"
                                className={
                                  isSkillSelected ? "bt remove" : "bt add"
                                }
                                onClick={() =>
                                  handleSkillTemplateChange(skillListTemplates)
                                }
                              >
                                {isSkillSelected ? "-" : "+"}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    ))}

                  {/* Pagination */}
                  {!skillIsInitialLoading && skillListTemplates.length > 0 && (
                    <div className="pagination">
                      <button
                        className={skillPage <= 1 ? "bt disabled" : "bt"}
                        type="button"
                        onClick={() => handleSkillPageChange(skillPage - 1)}
                        disabled={skillPage <= 1}
                      >
                        &lt;&lt;
                      </button>
                      <span>
                        {skillPage} /{" "}
                        {Math.ceil(skillListInfos.count / skillPageSize)}
                      </span>
                      <button
                        className={
                          skillPage >=
                          Math.ceil(skillListInfos.count / skillPageSize)
                            ? "bt disabled"
                            : "bt"
                        }
                        type="button"
                        onClick={() => handleSkillPageChange(skillPage + 1)}
                        disabled={
                          skillPage >=
                          Math.ceil(skillListInfos.count / skillPageSize)
                        }
                      >
                        &gt;&gt;
                      </button>
                    </div>
                  )}
                </div>

                {/* Ajout des sorts */}
                <div className="add-element list-page">
                  <h3>Liste des compétences ({spellListInfos.count})</h3>
                  {/* Filtres */}
                  <div className="filters">
                    <div className="spell-search">
                      <label htmlFor="spellsearch">Rechercher </label>
                      <input
                        type="text"
                        name="spellsearch"
                        id="spellsearch"
                        value={spellSearch}
                        onChange={(e) => (
                          setSpellSearch(e.target.value), setSpellPage(1)
                        )}
                      />
                    </div>
                    <div className="spell-pagesize">
                      <label htmlFor="spellpagesize">Taille de la page </label>
                      <select
                        name="spellpagesize"
                        id="spellpagesize"
                        value={spellPageSize}
                        onChange={(e) => (
                          setSpellPageSize(e.target.value), setSpellPage(1)
                        )}
                      >
                        <option value="6">6</option>
                        <option value="12">12</option>
                        <option value="24">24</option>
                      </select>
                    </div>
                  </div>

                  {/* Chargement initial */}
                  {spellIsInitialLoading && (
                    <div className="loading-data">
                      <div className="loading-spinner"></div>
                      <div className="loading-text">Chargement...</div>
                    </div>
                  )}

                  {/* Liste des compétences */}
                  {!spellIsInitialLoading &&
                    (spellListTemplates.length === 0 ? (
                      <div className="no-data">
                        <strong>Aucune compétence trouvée</strong>
                      </div>
                    ) : (
                      <div
                        className={`list-div spells ${
                          spellIsRefreshing ? "loading" : ""
                        }`}
                      >
                        {spellListTemplates.map((spellListTemplates) => {
                          const isSpellSelected = spellsTemplates.some(
                            (spells) => spells.id === spellListTemplates.id
                          );

                          return (
                            <div
                              className="list-card"
                              key={spellListTemplates.id}
                            >
                              {spellListTemplates.name} (
                              {spellListTemplates.attributes
                                .map((attribute) => attribute.full_name)
                                .join(", ")}
                              )
                              <button
                                type="button"
                                className={
                                  isSpellSelected ? "bt remove" : "bt add"
                                }
                                onClick={() =>
                                  handleSpellTemplateChange(spellListTemplates)
                                }
                              >
                                {isSpellSelected ? "-" : "+"}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    ))}

                  {/* Pagination */}
                  {!spellIsInitialLoading && spellListTemplates.length > 0 && (
                    <div className="pagination">
                      <button
                        className={spellPage <= 1 ? "bt disabled" : "bt"}
                        type="button"
                        onClick={() => handleSpellPageChange(spellPage - 1)}
                        disabled={spellPage <= 1}
                      >
                        &lt;&lt;
                      </button>
                      <span>
                        {spellPage} /{" "}
                        {Math.ceil(spellListInfos.count / spellPageSize)}
                      </span>
                      <button
                        className={
                          spellPage >=
                          Math.ceil(spellListInfos.count / spellPageSize)
                            ? "bt disabled"
                            : "bt"
                        }
                        type="button"
                        onClick={() => handleSpellPageChange(spellPage + 1)}
                        disabled={
                          spellPage >=
                          Math.ceil(spellListInfos.count / spellPageSize)
                        }
                      >
                        &gt;&gt;
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="buttons">
                <button
                  className={isFormValid ? "bt" : "bt disabled"}
                  type="submit"
                  disabled={!isFormValid}
                >
                  Valider
                </button>
                <button
                  className="bt"
                  type="button"
                  onClick={() => setRedirectTo("/job-templates")}
                >
                  Annuler
                </button>
              </div>
            </form>
            {messageError.length > 0 && (
              <div className="errors">
                {messageError.map((messageError, index) => (
                  <span className="error" key={index}>
                    {messageError}
                  </span>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default JobTemplateNew;
